// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Tailwind from "./Tailwind.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function Header(props) {
  return React.createElement("h1", {
              ref: Caml_option.some(props.inputRef),
              className: "rounded-t-md ring-black ring-opacity-5 border-b bg-white text-3xl font-bold text-gray-900 " + Tailwind.padding + ""
            }, props.children);
}

var make = Header;

export {
  make ,
}
/* react Not a pure module */
